<div class="email-table-container">
  <!-- Search Section -->
  <div class="table-header">
    <div class="header-spacer"></div>
    
    <div class="search-container">
      <owc-input 
        variant="outlined" 
        rounded
        placeholder="Search..."
        class="search-field"
        [formControl]="searchBox">
        <owc-icon slot="suffix" *ngIf="searchBox.value" (click)="clearSearch()" style="cursor: pointer;">close</owc-icon>
      </owc-input>
    </div>
  </div>

  <!-- Table Section -->
  <div class="table-wrapper">
    <owc-card class="one-card-flat" style="position:relative">
      <owc-table class="email-table">
      
        <owc-table-header sticky>
          <owc-table-header-cell sortable [align]="'left'" [title]="'Country'" (sortOrderChange)="onSort('Country', $event.detail)">
            Country
          </owc-table-header-cell>
          <owc-table-header-cell sortable [align]="'left'" [title]="'Id'" (sortOrderChange)="onSort('Id', $event.detail)">
            Customer ID
          </owc-table-header-cell>
          <owc-table-header-cell sortable [align]="'left'" [title]="'Name'" (sortOrderChange)="onSort('Name', $event.detail)">
            Customer Name
          </owc-table-header-cell>
          <owc-table-header-cell sortable [align]="'left'" [title]="'Email'" (sortOrderChange)="onSort('Email', $event.detail)">
            Email
          </owc-table-header-cell>
          <owc-table-header-cell sortable [align]="'left'" [title]="'Date'" (sortOrderChange)="onSort('Date', $event.detail)">
            Date
          </owc-table-header-cell>
          <owc-table-header-cell sortable [align]="'left'" [title]="'Resend'" (sortOrderChange)="onSort('Resend', $event.detail)">
            Resend
          </owc-table-header-cell>
          <owc-table-header-cell sortable [align]="'left'" [title]="'Status'" (sortOrderChange)="onSort('Status', $event.detail)">
            Status
          </owc-table-header-cell>
        </owc-table-header>

        <owc-table-body>
          @if(paginatedData && paginatedData.length > 0) {
            @for(element of paginatedData; track element.CustomerId || $index) {
              <owc-table-row class="table-row" (click)="emailDetails(element)">
                <owc-table-simple-cell [title]="element.Country" style="cursor: pointer;">
                  {{ element.Country }}
                </owc-table-simple-cell>
                <owc-table-simple-cell [title]="element.CustomerId" style="cursor: pointer;">
                  <span class="truncate-text">{{ element.CustomerId }}</span>
                </owc-table-simple-cell>
                <owc-table-simple-cell [title]="element.CustomerName" style="cursor: pointer;">
                  <span class="truncate-text">{{ element.CustomerName }}</span>
                </owc-table-simple-cell>
                <owc-table-simple-cell [title]="element.CustomerContactEmail" style="cursor: pointer;">
                  <span class="truncate-text">{{ element.CustomerContactEmail }}</span>
                </owc-table-simple-cell>
                <owc-table-simple-cell [title]="element.Date" style="cursor: pointer;">
                  {{ element.Date }}
                </owc-table-simple-cell>
                <owc-table-simple-cell [title]="element.IsResend ? 'Yes' : 'No'" style="cursor: pointer;">
                  <span 
                    *ngIf="element.IsResend === true" 
                    class="resend-chip">
                    Yes
                  </span>
                  <span *ngIf="!element.IsResend">No</span>
                </owc-table-simple-cell>
                <owc-table-simple-cell [title]="element.DeliveryStatus" class="status-cell" style="cursor: pointer;">
                  <div class="status-content">
                    <span class="status-badge" [ngClass]="getDeliveryStatusClass(element.DeliveryStatus)">
                      {{ element.DeliveryStatus }}
                    </span>
                    <owc-icon class="arrow-icon" (click)="emailDetails(element); $event.stopPropagation()" style="cursor: pointer;">
                      arrow_forward
                    </owc-icon>
                  </div>
                </owc-table-simple-cell>
              </owc-table-row>
            }
          }
        </owc-table-body>
      </owc-table>
    </owc-card>
  </div>
   <owc-modal-dialog [(ngModel)]="visible">
        <dl-email-delivery-details [emailData]="emailData" (closeDialog)="onDialogClose($event)"></dl-email-delivery-details>
      </owc-modal-dialog>

  <!-- No Data State -->
  <div *ngIf="paginatedData?.length === 0" class="no-data-container">
    <p *ngIf="dataSource.length === 0">No data found</p>
    <p *ngIf="dataSource.length > 0 && filteredData.length === 0">No search results found</p>
  </div>

  <!-- Simple Pagination -->
  <div class="simple-pagination" *ngIf="totalCount > 0">
    <div class="pagination-left">
      <span class="items-per-page-label">Items per page:</span>
      <select 
        class="page-size-dropdown"
        [value]="pageSize" 
        (change)="onPageSizeChange($event)">
        <option *ngFor="let size of pageSizeOptions" [value]="size">
          {{ size }}
        </option>
      </select>
    </div>
    
    <div class="pagination-center">
      <span class="pagination-info">{{ startIndex }} - {{ endIndex }} of {{ totalCount }}</span>
    </div>
    
    <div class="pagination-right">
      <button 
        class="nav-button" 
        [disabled]="currentPage === 0"
        (click)="goToFirstPage()"
        title="First page">
        &#8810;
      </button>
      <button 
        class="nav-button" 
        [disabled]="currentPage === 0"
        (click)="goToPreviousPage()"
        title="Previous page">
        &#8249;
      </button>
      <button 
        class="nav-button" 
        [disabled]="currentPage >= totalPages - 1"
        (click)="goToNextPage()"
        title="Next page">
        &#8250;
      </button>
      <button 
        class="nav-button" 
        [disabled]="currentPage >= totalPages - 1"
        (click)="goToLastPage()"
        title="Last page">
        &#8811;
      </button>
    </div>
  </div>
</div>